'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { getChildBioPath } from '@sola/my-sdk/constants.ts';
import { DepartureCta } from '../../molecules/departure-cta/departure-cta.tsx';
import { SponsorshipLinkCard } from '../../molecules/sponsorship-card/sponsorship-card.tsx';
import { useSponsorshipsList } from './sponsorships-list.logic.ts';
import { SponsorshipsSkeleton } from './sponsorships-skeleton.tsx';

/**
 * Displays sponsorships sorted alphabetically by child name.
 */
export const SponsorshipsList = () => {
  const $ = _c(19);
  const {
    departureItems,
    isLoading,
    sponsorships,
    hasError
  } = useSponsorshipsList();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["my", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isShowingSkeletons = isLoading && !hasError;
  let t1;
  if ($[1] !== isShowingSkeletons) {
    t1 = isShowingSkeletons && <SponsorshipsSkeleton />;
    $[1] = isShowingSkeletons;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== departureItems || $[4] !== hasError || $[5] !== isShowingSkeletons) {
    t2 = !isShowingSkeletons && !hasError && departureItems.length > 0 && <div className="SponsorshipsList__departure-groups flex flex-col gap-comfy-xl max-w-container-lg">{departureItems.map(_temp)}</div>;
    $[3] = departureItems;
    $[4] = hasError;
    $[5] = isShowingSkeletons;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== hasError || $[8] !== isShowingSkeletons || $[9] !== sponsorships) {
    t3 = !isShowingSkeletons && !hasError && sponsorships.length > 0 && <div className="SponsorshipsList__group flex flex-col gap-comfy-xs max-w-container-lg">{sponsorships.map(_temp2)}</div>;
    $[7] = hasError;
    $[8] = isShowingSkeletons;
    $[9] = sponsorships;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== hasError || $[12] !== t) {
    t4 = hasError && <Alert variant="negative" title={t("my:sponsorships.queryError.title")} message={t("my:sponsorships.queryError.message")} action={<a href={t("my:ctas.contactSupport.url")}>{t("my:ctas.contactSupport.text")}</a>} />;
    $[11] = hasError;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <div className="SponsorshipsList max-w-md flex flex-col gap-comfy-xl">{t1}{t2}{t3}{t4}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
function _temp(item) {
  return <DepartureCta key={item.departedChild.globalId} departedChild={item.departedChild} departedCommitment={item.departedCommitment} offeredSub={item.offeredSub} autoAcceptDate={item.departure.autoAcceptDate} />;
}
function _temp2(sponsorship) {
  return <SponsorshipLinkCard key={sponsorship.internalId} commitment={sponsorship} href={getChildBioPath(sponsorship.participant?.globalId)} />;
}